import React, { useState,useEffect } from 'react'
import "../css/navbar.scss";
import { motion } from "framer-motion";
import logo from "../Images/owlLogo.png"
const NavBar = () => {
  const [show, setShow] = useState({})
  const controlNavbar = () => {
      if (window.scrollY > 10 ) {
          setShow({
            display:'none'
          })
      }else{
        setShow()
      }
  }
  useEffect(() => {
      window.addEventListener('scroll', controlNavbar)
      return () => {
          window.removeEventListener('scroll', controlNavbar)
      }
  }, []);

  return (
    <>

      <div style={show} className='navbar'>
        <div className="nav-title">
          <motion.h2
            initial={{ opacity: 0, x: +100, overflow: 'hidden' }} whileInView={{ opacity: 1, x: 0 }}
            whileHover={{ x: 10, cursor: 'pointer',fontStyle:'italic'}} >Night Owl Programmer <img src={logo} alt="Logo" /></motion.h2>
        </div>
      </div>
    </>
  )
}

export default NavBar